// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '동국제약',
  targetSheetName: 'Sheet1',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '약가',
    commissionRate: '수수료율',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '순서',
    '수수료율',
    '제조',
    '생동',
    '제약사',
    '등급',
    '보험코드',
    '제품명',
    '약가',
    '성 분 명',
    '비고',
  ],
});
